import cx from "classnames";

import Image from "common/components/Image";
import { smartSrc } from "common/utils/images";

import Header from "client/common/components/header/Header";

import { HomeThemeProps } from "../types";
import HomeContent from "./HomeContent";

import styles from "../styles/HomeThemeCutout.module.less";

const BlobOne = () => (
  <svg
    className={cx(styles.blob, styles.blobOne)}
    xmlns="http://www.w3.org/2000/svg"
    width="377"
    height="899"
    viewBox="0 0 377 899"
    fill="none"
  >
    <g opacity="0.09" filter="url(#filter0_d_4922_8050)">
      <path
        d="M-97.697 785.674C-43.5255 1012.82 97.0745 978.706 161.149 932.731C260.115 848.804 272.874 651.061 275.123 574.041C276.923 512.425 316.155 360.217 335.545 291.814C357.183 49.5722 175.954 63.9239 143.708 64.6449C111.461 65.3659 8.55701 106.631 -92.8733 64.8733C-174.018 31.4672 -249.79 33.3432 -277.533 38.457C-396.124 80.1582 -389.836 171.976 -386.659 211.797C-383.482 251.618 -354.35 329.347 -234.36 424.881C-138.369 501.307 -102.891 696.905 -97.697 785.674Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4922_8050"
        x="-426.932"
        y="0.589355"
        width="803.265"
        height="1008.74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="19.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.542422 0 0 0 0 0.612139 0 0 0 0 0.683171 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4922_8050" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4922_8050"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const BlobTwo = () => (
  <svg
    className={cx(styles.blob, styles.blobTwo)}
    xmlns="http://www.w3.org/2000/svg"
    width="797"
    height="440"
    viewBox="0 0 797 440"
    fill="none"
  >
    <g opacity="0.08" filter="url(#filter0_d_4922_8048)">
      <path
        d="M625.236 -539.855C584.071 -824.502 410.03 -807.592 327.438 -763.016C198.477 -678.517 161.711 -441.128 150.686 -348.193C141.867 -273.846 77.93 -96.2311 47.0641 -16.7173C-5.25521 273.049 215.886 287.146 255.037 291.875C294.188 296.604 423.323 264.482 541.727 332.702C636.45 387.279 728.466 398.17 762.633 396.794C910.824 366.869 913.098 254.521 913.538 205.717C913.979 156.914 887.055 57.6685 751.957 -78.9367C643.879 -188.221 621.966 -431.391 625.236 -539.855Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4922_8048"
        x="0.10083"
        y="-823.344"
        width="952.443"
        height="1263.25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="19.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.542422 0 0 0 0 0.612139 0 0 0 0 0.683171 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4922_8048" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4922_8048"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const BlobThree = () => (
  <svg
    className={cx(styles.blob, styles.blobThree)}
    xmlns="http://www.w3.org/2000/svg"
    width="461"
    height="845"
    viewBox="0 0 461 845"
    fill="none"
  >
    <g opacity="0.13" filter="url(#filter0_d_4922_8049)">
      <path
        d="M422.118 714.819C521.332 868.004 621.195 784.373 659.013 722.783C714.16 617.688 674.021 459.911 656.288 399.566C642.102 351.29 633.899 217.857 631.57 157.175C587.034 -38.5565 450.827 46.3846 426.128 60.0843C401.429 73.7841 332.46 147.567 243.642 156.689C172.588 163.987 114.597 196.319 94.483 211.573C13.5198 292.086 41.5803 360.369 54.0975 389.799C66.6147 419.23 108.74 467.331 225.471 492.137C318.856 511.982 395.672 648.443 422.118 714.819Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4922_8049"
        x="0.0778809"
        y="-4.97412"
        width="725.984"
        height="849.662"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="19.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.542422 0 0 0 0 0.612139 0 0 0 0 0.683171 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4922_8049" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4922_8049"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const Star = ({ className }: { className: string }) => (
  <svg
    className={cx(styles.star, className)}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
  >
    <path
      d="M26.5 0V25.9362H0L2.31922 25.2741C13.6542 22.0384 22.5175 13.3637 25.8236 2.26988L26.5 0Z"
      fill="white"
      fillOpacity="0.25"
    />
    <path
      d="M26.5 53V25.9362H0L2.39109 26.6484C13.682 30.0117 22.4392 38.7809 25.6163 49.9057L26.5 53Z"
      fill="white"
      fillOpacity="0.25"
    />
    <path
      d="M26.5 0V25.9362H53L50.6808 25.2741C39.3458 22.0384 30.4825 13.3637 27.1764 2.26988L26.5 0Z"
      fill="white"
      fillOpacity="0.25"
    />
    <path
      d="M26.5 53V25.9362H53L50.6089 26.6484C39.318 30.0117 30.5608 38.7809 27.3837 49.9057L26.5 53Z"
      fill="white"
      fillOpacity="0.25"
    />
  </svg>
);

const HomeThemeCutout = ({ storefrontThemeConfig }: HomeThemeProps) => {
  const { color, logo, image } = storefrontThemeConfig;
  const gradient = `linear-gradient(135deg, ${color?.primary_hex}, ${color?.secondary_hex})`;
  return (
    <div>
      <div className={styles.theme} style={{ background: gradient }}>
        <Header storefrontThemeLogo={logo} bannerVariant="semi-transparent" hasWhiteIcons={true} />
        <HomeContent.Header>
          <div className={styles.contentHeader}>
            <HomeContent.Title className={styles.headerTitle} />
          </div>
        </HomeContent.Header>
        {image ? (
          <div className={styles.cutoutImageContainer}>
            <picture>
              <source
                media="(max-width: 800px)"
                srcSet={smartSrc(image.image_mobile ?? image.image)}
              />
              <source media="(max-width: 1200px)" srcSet={smartSrc(image.image)} />
              <source
                media="(min-width: 1201px)"
                srcSet={smartSrc(image.image_2x ?? image.image)}
              />
              <Image
                className={styles.cutoutImage}
                alt="storefront theme image"
                src={smartSrc(image.image)}
              />
            </picture>
          </div>
        ) : (
          <div className={styles.noImage} />
        )}
        <BlobOne />
        <BlobTwo />
        <BlobThree />
        <Star className={styles.starOne} />
        <Star className={styles.starTwo} />
        <Star className={styles.starThree} />
        <Star className={styles.starFour} />
        <Star className={styles.starFive} />
        <Star className={styles.starSix} />
      </div>
      <HomeContent.Body hasLoggedinSummary={true} />
    </div>
  );
};

export default HomeThemeCutout;
